import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoCarouselPanelComponent } from './video-carousel-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [VideoCarouselPanelComponent],
  exports: [VideoCarouselPanelComponent],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule
  ],
})
export class VideoCarouselPanelModule { }
